import Axios from "axios";

export const getClaimExtractions = (
  token,
  { page = 1, pageSize = 50, searchText = "" } = {},
) => {
  return Axios.get(
    `${process.env.REACT_APP_NOT_SECRET_CODE}/ai_extractions`,
    {
      params: {
        page,
        page_size: pageSize,
        search_text: searchText,
      },
      headers: {
        "Content-Type": "application/json",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: `Bearer ${token}`,
      },
    },
  ).then((res) => res.data);
};
